/// <amd-module name="VSSUI/Components/PersonaCard/DefaultAbridgedCard" />
import * as React from "react";
import * as Resources from "VSSUI/VSS.Resources.VSSUI";

import { Label } from "OfficeFabric/Label";
import { VssPersona, IVssPersonaProps } from "VSSUI/VssPersona";
import { DefaultCardContactLine } from "./DefaultCard";
import { ContactCardProps } from "./ContactCard.Props";

/** @deprecated */
export class DefaultAbridgedCard extends React.Component<ContactCardProps> {
    // Render
    public render(): JSX.Element {
        const mainPersonaData = {
            imageUrl: this.props.identity.image,
            primaryText: this.props.identity.displayName
        };
        const mainPersona = (
            <div className="flex-row">
                <VssPersona
                    className="persona-main"
                    displayName={mainPersonaData.primaryText}
                    imageUrl={ mainPersonaData.imageUrl ? mainPersonaData.imageUrl+"?size=2" : undefined}
                    size="extra-large"
                    suppressPersonaCard={true}
                />
                <div className="flex-column flex-grow persona-card-name">
                    <div className="persona-main-text-primary">{mainPersonaData.primaryText}</div>
                </div>
            </div>
        );

        return (
            <div className="default-card-abridged flex-row">
                {/* Main persona display */}
                {mainPersona}

                {/* Section to hold contact information */}
                {this._verifySignInAddress() && (
                    <div>
                        {/* Brief contact information */}
                        <div className="default-card-contact-info-wrapper">
                            <hr className="hr-main" />

                            <div className="default-card-header-wrapper">
                                <span className="default-card-header">
                                    <Label>
                                        <b className="default-card-header-space">{Resources.PeoplePickerContact}</b>
                                    </Label>
                                </span>
                            </div>

                            {
                                <div className="default-card-contact-info-container">
                                    <DefaultCardContactLine
                                        iconName="Mail"
                                        content={this.props.identity.signInAddress}
                                        link={`mailto:${this.props.identity.signInAddress}`}
                                    />
                                    <DefaultCardContactLine
                                        iconName="Chat"
                                        content={Resources.PeoplePickerStartChat}
                                        link={`sip:${this.props.identity.signInAddress}`}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                )}
            </div>
        );
    }

    private _verifySignInAddress(): boolean {
        if (!this.props.identity.signInAddress) {
            return false;
        }

        // this is copied from System.ComponentModel.DataAnnotations.EmailAddressAttribute
        const PROFILE_EMAIL_ADDRESS_PATTERN: RegExp = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;

        if (PROFILE_EMAIL_ADDRESS_PATTERN.test(this.props.identity.signInAddress)) {
            return true;
        }

        return false;
    }
}
